import {Component, OnDestroy} from "@angular/core";
import {ConfigurationService} from "@fedeltapointofsale/data-client";
import {Router} from "@angular/router";
import {EntityImportAction, EntityImportActionResp, EntityImportService} from "../entity-import.service";
import {first, Subscription, timer} from "rxjs";
import {
    EntityImportStatusAction,
    EntityImportStatusActionResp,
    EntityImportStatusService,
    ImportStatus
} from "../entity-import-status.service";

/**
 * Entity import
 */
@Component({
    selector: "wbo-file-import-page",
    templateUrl: "./file-import-page.component.html",
    styleUrls: ["./file-import-page.component.scss"],
    providers: [EntityImportService, EntityImportStatusService]
})
export class FileImportPageComponent implements OnDestroy {

    importing: boolean;
    success: boolean;
    started: boolean;

    percentageComplete: number = 0;

    importId: string;


    private subscription: Subscription;

    constructor(
        private configService: ConfigurationService,
        private router: Router,
        private entityImportService: EntityImportService,
        private entityImportStatusService: EntityImportStatusService) {
    }

    ngOnDestroy(): void {
        if (this.subscription) {
            this.subscription.unsubscribe();
        }
    }

    importFile(event: any): void {
        this.started = true;

        this.entityImportService.performAction(new EntityImportAction(event)).then((resp: EntityImportActionResp) => {
            this.importId = resp.id;
            this.initPoll(true);
        });

        this.importing = true;
    }

    onCancel(): void {
        this.router.navigate([""], {replaceUrl: true});
    }

    private initPoll(delay?: boolean): void {
        this.subscription = timer(delay ? 3000 : 0).pipe(first()).subscribe(() => this.checkStatus());
    }

    private checkStatus(): void {
        this.entityImportStatusService.performAction(new EntityImportStatusAction(this.importId)).then((resp: EntityImportStatusActionResp) => {
            if (resp.status === ImportStatus.WAITING || resp.status === ImportStatus.PROCESSING) {
                this.initPoll(true);
            } else {
                this.importing = false;
                this.success = resp.status === ImportStatus.COMPLETE;
            }
            this.percentageComplete = resp.percentageComplete;
        }).catch((error) => {
            console.log("failed to check import status...");
            console.log(error);
            this.initPoll(true);
        });
    }


}
